import { Injectable } from "@angular/core";
import {
  Response,
  RequestOptions,
  ResponseContentType,
  Http,
  Headers,
} from "@angular/http";
import { Observable } from "rxjs/Observable";
import { WebService } from "../web.service";
import "rxjs/add/operator/map";

@Injectable()
export class CitationService extends WebService {
  public getCitation(
    page?: number,
    per_page?: number,
    sort?: string,
    query?: string,
    filters?: any[]
  ): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append("_page", String(page));
    } else {
      params.append("_page", "1");
    }

    if (per_page !== null && per_page !== undefined) {
      params.append("_limit", String(per_page));
    } else {
      params.append("_limit", "10");
    }

    if (sort !== null && sort !== undefined) {
      params.append("_sort", String(sort));
    }

    if (query !== null && query !== undefined && query !== "") {
      params.append("_q", String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach((element) => {
        params.append(element.key, String(element.value));
      });
    }

    params.append(
      "_with",
      String(
        "requisition.employee,company,venue,profile_survey.checklist_profile_survey.list_doc_profile_survey," +
          "document_profile_survey,profile_survey.checklist_profile_survey.document_profile_survey,candidate,hiring_analyst,citation_justification.user.employee"
      )
    );

    const options = new RequestOptions({
      search: params,
      headers: this.headers,
    });

    return this.http.get(`${this.apiUrl}/citations?${params}`, options);
  }

  public getCitationByRequisition(
    id: number,
    page?: number,
    per_page?: number,
    sort?: string,
    query?: string,
    filters?: any[]
  ): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append("_page", String(page));
    } else {
      params.append("_page", "1");
    }

    if (per_page !== null && per_page !== undefined) {
      params.append("_limit", String(per_page));
    } else {
      params.append("_limit", "10");
    }

    if (sort !== null && sort !== undefined) {
      params.append("_sort", String(sort));
    }

    if (query !== null && query !== undefined && query !== "") {
      params.append("_q", String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach((element) => {
        params.append(element.key, String(element.value));
      });
    }

    params.append(
      "_with",
      String(
        "requisition.employee,company,venue,profile_survey.checklist_profile_survey.list_doc_profile_survey," +
          "document_profile_survey,profile_survey.checklist_profile_survey.document_profile_survey,candidate,hiring_analyst,citation_justification.user.employee"
      )
    );

    const options = new RequestOptions({
      search: params,
      headers: this.headers,
    });

    return this.http.get(
      `${this.apiUrl}/requisitions/${id}/citations?${params}`,
      options
    );
  }

  public infoCitationMedicalExam(
    id: number,
    _with: string
  ): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();
    if (_with != "" && _with != undefined && _with != null)
      params.append("_with", String(_with));
    const options = new RequestOptions({
      search: params,
      headers: this.headers,
    });
    return this.http.get(
      `${this.apiUrl}/citations/${id}/medical-exams?${params}`,
      options
    );
  }

  public generateOrdenMedicalExam(
    body: Object,
    id: number
  ): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/citations/${id}/medical-exams`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public reprogrammingOrdenMedicalExam(
    body: Object,
    id: number
  ): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/citations/${id}/medical-exams/reprogramming`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public newCitation(body: Object): Observable<Response> {
    return this.http.post(`${this.apiUrl}/citations`, JSON.stringify(body), {
      headers: this.headers,
    });
  }

  public updateCitation(id: number, body: Object): Observable<Response> {
    return this.http.patch(
      `${this.apiUrl}/citations/${id}`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public deleteCitation(id: number): Observable<Response> {
    return this.http.delete(`${this.apiUrl}/citations/${id}`, {
      headers: this.headers,
    });
  }

  public infoCitation(id: number, _with: string): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();
    // params.append('id', String(id));
    // params.append('_sort', String('-newnesses.created_at'));
    // params.append('_with', String('station,newnesses.user.employee'));
    //params.append('_with', String('citation_justification.user.employee'));
    if (_with != "" && _with != undefined && _with != null)
      params.append("_with", String(_with));

    const options = new RequestOptions({
      search: params,
      headers: this.headers,
    });

    return this.http.get(`${this.apiUrl}/citations/${id}?${params}`, options);
  }

  public infoRequisition(id: number): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();
    params.append("id", String(id));
    const options = new RequestOptions({
      search: params,
      headers: this.headers,
    });
    return this.http.get(
      `${this.apiUrl}/requisitions/requisitionsAllLow?${params}`,
      options
    );
  }

  public citationsTransferService(
    requisitionid: number,
    body: Object
  ): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/citations/${requisitionid}/transfercitations`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  // public docsFromHVtoKaizenService( body: Object):Observable<Response>{
  //     return this.http.post(`${this.apiUrl}/hojasdevidas/CopyFilesfromHv`, JSON.stringify(body),{ headers: this.headers });
  // }

  public docsFromHVtoLucianaService(body: Object): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/documents-candidate/copy-files-from-Hv`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public botzyManagementDocumental(body: Object): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/management-documental-botzy`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public botzyRejectedCandidate(body: Object): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/rejected-candidate-botzy`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public botzyHire(body: Object): Observable<Response> {
    // return this.http.post( `${this.apiUrl}/hire-message-botzy`, JSON.stringify(body) , { headers: this.headers } );
    return this.http.post(
      `${this.apiUrl}/twilio/hire-message-twilio`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public incomeOrderCustomerNotification(
    id: number,
    body: Object
  ): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/citations/${id}/customer-notify`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public incomeOrderMassiveCustomerNotification(
    ids: number[],
    body: Object
  ): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/citations/massive-customer-notify`,
      JSON.stringify({ citations_ids: ids, ...body }),
      { headers: this.headers }
    );
  }

  public massiveIncomeOrderAuthorization(body: Object): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/citations/massive-income-order-authorization`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public restartSendIncomeOrderCitation(id: number): Observable<Response> {
    return this.http.patch(
      `${this.apiUrl}/citations/${id}/restart-income-order`,
      {},
      { headers: this.headers }
    );
  }

  public assignToMeHireCitation(id: number): Observable<Response> {
    return this.http.patch(
      `${this.apiUrl}/citations/${id}/assign-to-me-hire`,
      {},
      { headers: this.headers }
    );
  }

  public validationPDFDocumentalHunterx(citationId: number): Observable<Blob> {
    return this.http
      .get(
        `${this.apiUrl}/citations/${citationId}/validation-hunterx?getPdf=true`,
        {
          headers: this.headers,
          responseType: ResponseContentType.Blob,
        }
      )
      .map((response) => response.blob());
  }

  public validationDocumentalHunterx(citationId: number): Observable<Response> {
    return this.http.get(
      `${this.apiUrl}/citations/${citationId}/validation-hunterx`,
      {
        headers: this.headers,
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/citation/citation.service.ts